import axios from 'axios'

const s3 = axios.create()

export default s3
